"use strict";

exports.__esModule = true;
exports.PlainText = PlainText;
var _react = _interopRequireDefault(require("react"));
var _excluded = ["component", "content"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Turns newline delimited content into react elements.
 * @component
 */
function PlainText(_ref) {
  var _ref$component = _ref.component,
    Component = _ref$component === void 0 ? "p" : _ref$component,
    content = _ref.content,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  return (Array.isArray(content) ? content : [content]).reduce(function (body, item, index) {
    var parts = item.trim().split(/\r?\n/);
    for (var i = 0; i < parts.length; i++) {
      body.push(/*#__PURE__*/_react["default"].createElement(Component, _extends({
        key: String(index) + ":" + String(i)
      }, extra), parts[i], "\xA0"));
    }
    return body;
  }, []);
}